import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Country, I18nModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { BehaviorSubject, Observable, of, take } from 'rxjs';
import { CountriesDropdownComponent } from '../../../../../../../../components/form-elements/countries-dropdown/countries-dropdown.component';
import { Option } from '../../../../../../../../core/models/option.model';
import { UserAuxService } from '../../../../../core/user-aux.service';
import { LoaderService } from '../../../../../../../../components/loader/loader.service';
import { ToasterService } from '../../../../../../../../components/toaster/toaster.service';

@Component({
  selector: 'form-address',
  standalone: true,
  imports: [CommonModule, I18nModule, ReactiveFormsModule, FormErrorsModule, CountriesDropdownComponent],
  templateUrl: './form-address.component.html',
  styleUrl: './form-address.component.scss',
})
export class FormAddressComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() countries$: Observable<Country[]> = of([]);
  stateRegions$ = new BehaviorSubject<Option[]>([]);

  country?: Country;

  constructor(
    private toasterService: ToasterService,
    private loaderService: LoaderService,
    private userAuxService: UserAuxService,
  ) {}

  ngOnInit(): void {
    this.country = { isocode: this.form.get('country')?.value };
    !this.form.disabled && this.country.isocode && this.getStateRegions(this.country);
  }

  setCountry(country: Country) {
    if (country.isocode !== this.country?.isocode) {
      this.country = country;
      this.form.get('country')?.setValue(country.isocode);
      this.getStateRegions(country);
    }
  }

  getStateRegions(country: Country) {
    this.loaderService.start();
    country.isocode &&
      this.userAuxService
        .getStateRegions(country.isocode)
        .pipe(take(1))
        .subscribe(response => {
          this.loaderService.stop();

          if (response.hasError) {
            this.toasterService.displayError(response.message!);
          }

          this.stateRegions$.next(response.options || []);
        });
  }
}
